<template>
  <div style="height: calc(100vh - 196px)">
    <vxe-toolbar
      id="toolbarId_tr4"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="waybillManage_wait_search_button" @click="funcFilter"
          >查询</el-button
        >
        <el-button
          v-if="getLimit('waybillManage_wait_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <!-- :row-class-name="rowClassName" -->
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      class="mytable-style"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="托运人"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入托运人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="dfName"
          title="经办人"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.dfName"
            placeholder="请输入经办人"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 托运人电话 -->
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByPhone"
          title="托运人电话"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByPhone"
            placeholder="请输入托运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentStaffTypeStr"
          title="托运人类型"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.shipmentStaffType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in shipmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="deleted"
          title="取消状态"
          :formatter="formatterCancel"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isCancel"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in cancelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入货源单号"
            clearable
          />
        </template>
      </vxe-table-column>

      <!-- <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column> -->

      <vxe-table-column>
        <vxe-table-column
          field="isMonthlyOrder"
          title="结算类型"
          min-width="100"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isMonthlyOrder')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMonthlyOrder"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.isMonthlyOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!--<vxe-table-column v-if="isDriver">
        <vxe-table-column field="status" title="运单状态" :formatter="formatterStatus" min-width="130" sortable />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </vxe-table-column>-->
      <vxe-table-column>
        <vxe-table-column
          field="isTransfer"
          title="是否调单"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.isTransfer > 0 ? "是" : "否" }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.isTransferSearch"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in isTransferSearchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物名称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入货物名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalPrice"
          title="货物单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalName"
          title="运输要求"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalName"
            placeholder="请输入运输要求"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="卸货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入卸货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="distance"
          title="里程数(公里)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.distanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.distanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队名称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人电话"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入实际承运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="weight"
          title="接单数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.weightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.weightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="maxPrice"
          title="最高价"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxPricend"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxPrice"
          title="托运人成交单价"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxFee"
          title="托运人预估运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="prePay"
          title="托运人预付运费(元)"
          min-width="180"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.prePay + row.abnormalFee }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.prePayStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.prePayEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="arrivePay"
          title="到付款费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.arrivePayStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.arrivePayPayEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="returnPay"
          title="回单付款费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.returnPayStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.returnPayEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxPayFee"
          title="服务费(元)"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPayFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPayFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="driftPrice"
          title="浮动费用(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driftPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driftPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="realPrice"
          title="实际承运人承运单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.realPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.realPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="deliveryFeeDeserved"
          title="实际承运人预估净得运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeeDeservedStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeeDeservedEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="platformPrepayment"
          title="平台预付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.platformPrepaymentStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.platformPrepaymentEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="payOil"
          title="平台预付油点(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payOilStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payOilEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="payAmount"
          title="平台预付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isAdmin">
        <vxe-table-column field="taxPayFee" title="服务费(元)" min-width="200" sortable />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.taxPayFeeStart" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input v-model="listQuery.taxPayFeeEnd" type="number" placeholder="上限" clearable />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!--      <vxe-table-column>-->
      <!--        <vxe-table-column field="payStatus" title="支付状态" :formatter="formatterPayStatus" min-width="200" sortable />-->
      <!--        <template v-slot:header>-->
      <!--          <el-select v-model="listQuery.payStatus" clearable placeholder="请选择">-->
      <!--            <el-option-->
      <!--              v-for="item in payOptions"-->
      <!--              :key="item.value"-->
      <!--              :label="item.label"-->
      <!--              :value="item.value"-->
      <!--            />-->
      <!--          </el-select>-->
      <!--        </template>-->
      <!--      </vxe-table-column>-->
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="接单时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastLoadingTime"
          title="截止装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastLoadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastLoadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastUnloadingTime"
          title="截止卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastUnloadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastUnloadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isAdmin">
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入最后操作人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column title="操作" width="200" fixed="right">
          <template v-slot="{ row }">
            <!--<el-tooltip class="item" effect="dark" content="定位" placement="top">
              <vxe-button type="text" @click="positionFunc(row)">
                <em class="el-icon-location-information" />
              </vxe-button>
            </el-tooltip>-->
            <el-tooltip
              v-if="waybillManage_wait_detail_button"
              class="item"
              effect="dark"
              content="详情"
              placement="top"
            >
              <vxe-button type="text" @click="WaybillDetails(row.code, row)">
                <em class="el-icon-document" />
              </vxe-button>
            </el-tooltip>
            <!-- <el-tooltip
              v-if="
                waybillManage_wait_cancelOrder_button &&
                  row.btnArr.indexOf('cancelOrder') > -1
              "
              class="item"
              effect="dark"
              content="取消订单"
              placement="top"
            >
              <vxe-button type="text" @click="cancelOrderFunc(row)">
                <em class="el-icon-circle-close" />
              </vxe-button>
            </el-tooltip>

            <el-tooltip
              v-if="
                waybillManage_wait_cancelAffirm_button &&
                  row.btnArr.indexOf('cancelAffirm') > -1
              "
              class="item"
              effect="dark"
              content="取消确认"
              placement="top"
            >
              <vxe-button type="text" @click="cancelAffirmFunc(row)">
                <em class="el-icon-document" />
              </vxe-button>
            </el-tooltip> -->
            <!-- <el-tooltip
              v-if="
                waybillManage_wait_sendOrder_button &&
                  row.btnArr.indexOf('sendOrder') > -1
              "
              class="item"
              effect="dark"
              content="派单"
              placement="top"
            >
              <vxe-button type="text" @click="sendOrderFunc(row)">
                <em class="el-icon-document" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="
                waybillManage_wait_load_button &&
                  row.btnArr.indexOf('load') > -1
              "
              class="item"
              effect="dark"
              content="装货"
              placement="top"
            >
              <vxe-button type="text" @click="loadFunc(row)">
                <em class="el-icon-truck" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="
                waybillManage_wait_unload_button &&
                  row.btnArr.indexOf('unload') > -1
              "
              class="item"
              effect="dark"
              content="卸货"
              placement="top"
            >
              <vxe-button type="text" @click="unloadFunc(row)">
                <em class="el-icon-truck" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="
                waybillManage_wait_loadAffirm_button &&
                  row.btnArr.indexOf('loadAffirm') > -1
              "
              class="item"
              effect="dark"
              content="装货确认"
              placement="top"
            >
              <vxe-button type="text" @click="loadAffirmFunc(row)">
                <em class="el-icon-check" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="
                waybillManage_wait_reload_button &&
                  row.btnArr.indexOf('reload') > -1
              "
              class="item"
              effect="dark"
              content="重新装货"
              placement="top"
            >
              <vxe-button type="text" @click="reloadFunc(row)">
                <em class="el-icon-delete" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="
                waybillManage_wait_unloadAffirm_button &&
                  row.btnArr.indexOf('unloadAffirm') > -1
              "
              class="item"
              effect="dark"
              content="确认签收"
              placement="top"
            >
              <vxe-button type="text" @click="unloadAffirmFunc(row)">
                <em class="el-icon-check" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="
                waybillManage_wait_reunload_button &&
                  row.btnArr.indexOf('reunload') > -1
              "
              class="item"
              effect="dark"
              content="重新卸货"
              placement="top"
            >
              <vxe-button type="text" @click="reunloadFunc(row)">
                <em class="el-icon-info" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="
                waybillManage_wait_exchange_button &&
                  row.btnArr.indexOf('exchange') > -1
              "
              class="item"
              effect="dark"
              content="调单"
              placement="top"
            >
              <vxe-button type="text" @click="exchangeFunc(row)">
                <em class="el-icon-document-checked" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="
                waybillManage_wait_del_button && row.btnArr.indexOf('del') > -1
              "
              class="item"
              effect="dark"
              content="删除"
              placement="top"
            >
              <vxe-button type="text" @click="delFunc(row)">
                <em class="el-icon-delete" />
              </vxe-button>
            </el-tooltip> -->
          </template>
        </vxe-table-column>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="WaybillFalse"
      title="运单详情"
      width="1000"
      height="auto"
      resize
      remember
    >
      <ordergoods
        ref="WaybillDetails"
        :orderInfo="wayInfo"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <!--<vxe-modal v-model="positionFlag" title="定位" width="1000" height="800" resize remember>
      <Position
        ref="positionRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>-->
    <vxe-modal
      v-model="cancelAffirmFlag"
      title="取消确认"
      width="600"
      height="auto"
      resize
      remember
    >
      <CancelAffirm
        ref="cancelAffirmRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="cancelOrderFlag"
      title="取消订单"
      width="600"
      height="auto"
      resize
      remember
    >
      <CancelOrder
        ref="cancelOrderRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="loadFlag"
      title="装货"
      width="600"
      height="auto"
      resize
      remember
    >
      <!-- <Load
        ref="loadRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      /> -->
      <LoadNew
        ref="loadRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="reloadFlag"
      title="重新装货"
      width="600"
      height="auto"
      resize
      remember
    >
      <Reload
        ref="reloadRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="loadAffirmFlag"
      title="装货确认"
      width="600"
      height="auto"
      resize
      remember
    >
      <LoadAffirm
        ref="loadAffirmRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="unloadFlag"
      title="卸货"
      width="600"
      height="auto"
      resize
      remember
    >
      <Unload
        ref="unloadRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="reunloadFlag"
      title="重新卸货"
      width="600"
      height="auto"
      resize
      remember
    >
      <Reunload
        ref="reunloadRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="unloadAffirmFlag"
      title="确认签收"
      width="600"
      height="auto"
      resize
      remember
    >
      <UnloadAffirm
        ref="unloadAffirmRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="sendOrderFlag"
      title="派单"
      width="600"
      height="80%"
      resize
      remember
    >
      <SendOrder
        ref="sendOrderRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="exchangeFlag"
      title="调单"
      width="600"
      height="auto"
      resize
      remember
    >
      <Exchange
        ref="exchangeRef"
        :type="type"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
import CancelOrder from "./components/CancelOrder.vue";
// import Load from "./components/Load.vue";
// import Position from "./components/Position.vue";
import CancelAffirm from "./components/CancelAffirm.vue";
import ordergoods from "@/components/WaybillDetails";
import SendOrder from "./components/SendOrder.vue";
import Unload from "./components/Unload.vue";
import LoadAffirm from "./components/LoadAffirm.vue";
import Reload from "./components/Reload.vue";
import LoadNew from "./components/LoadNew.vue";
import UnloadAffirm from "./components/UnloadAffirm.vue";
import Reunload from "./components/Reunload.vue";
import Exchange from "./components/Exchange.vue";
import { deleteDetail } from "@/api/transport";
import { getLimit } from "@/utils/getLimit.js";
export default {
  name: "WaitTransport",
  components: {
    CancelOrder,
    // Load,
    LoadNew,
    //Position,
    CancelAffirm,
    SendOrder,
    Unload,
    LoadAffirm,
    Reload,
    UnloadAffirm,
    Reunload,
    Exchange,
    ordergoods
  },
  props: {
    isAllowLoadOrUnload: {
      type: String,
      default() {
        return "0";
      }
    },
    // 判断类型
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetail/exportDetailWait", //导出接口
        name: "运单跟踪待运输列表"
      },
      cancelOrderFlag: false,
      WaybillFalse: false,
      loadFlag: false,
      positionFlag: false,
      cancelAffirmFlag: false,
      sendOrderFlag: false,
      unloadFlag: false,
      loadAffirmFlag: false,
      reloadFlag: false,
      unloadAffirmFlag: false,
      reunloadFlag: false,
      exchangeFlag: false,
      waybillManage_wait_search_button: false, //查询
      waybillManage_wait_detail_button: false, //详情
      waybillManage_wait_cancelOrder_button: false, //取消订单
      waybillManage_wait_cancelAffirm_button: false, //取消确认
      waybillManage_wait_sendOrder_button: false, //派单
      waybillManage_wait_load_button: false, //装货
      waybillManage_wait_unload_button: false, //卸货
      waybillManage_wait_loadAffirm_button: false, //装货确认
      waybillManage_wait_reload_button: false, //重新装货
      waybillManage_wait_unloadAffirm_button: false, //卸货确认
      waybillManage_wait_reunload_button: false, //重新卸货
      waybillManage_wait_exchange_button: false, //调单
      waybillManage_wait_del_button: false, //删除
      loading: false,
      tableData: [],
      parentData: {
        isMonthlyOrderOptions: []
      },
      shipperDetail: false,
      isAdmin: false,
      isShipmentOrAdmin: false,
      isDriverOrAdmin: false,
      isDriver: false,
      sumObject: {},
      listQuery: {
        lastUnloadingTimeRange: "",
        lastLoadingTimeRange: "",
        gmtCreatedRange: "",
        gmtModifiedRange: "",
        orderCode: "", // 运输单号
        mainOrderNumber: "", // 货源单号
        ordCreatedByName: "", // 托运人/托运人
        shipperInfo: "", // 装货信息：装货地/装货电话/发货联系人
        consigneeInfo: "", // 	收货信息：目的地/收货电话/卸货联系人
        driverPhone: "", // 实际承运人手机号
        vehicleLicense: "", // 车牌号
        teamName: "", // 承运车队
        companyName: "", // 托运人
        gmtCreatedStart: "", // 运单创建时间
        gmtCreatedEnd: "", // 运单创建时间
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        // status: 1,
        total: 0
      },
      cancelOptions: [
        {
          label: "正常",
          value: 0,
          color: "gray"
        },
        {
          label: "撤单申请",
          value: 1,
          color: "#0000ff"
        },
        {
          label: "同意撤销",
          value: 2,
          color: "#ff0000"
        },
        {
          label: "拒绝撤销",
          value: 3,
          color: "#00bd93"
        }
      ],
      payOptions: [
        {
          label: "未支付",
          value: 0
        },
        {
          label: "处理中",
          value: 1
        },
        {
          label: "已支付",
          value: 2
        },
        {
          label: "已失败",
          value: 3
        }
      ],
      isTransferSearchOptions: [
        { value: 0, label: "否" },
        { value: 1, label: "是" }
      ],
      statusOptions: [
        { value: 1, label: "已接单" },
        { value: 2, label: "已装货" },
        { value: 3, label: "已卸货" },
        { value: 4, label: "已结算" },
        { value: 5, label: "已打款" }
      ],
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      wayInfo: null
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isShipmentOrAdmin =
      partyType == "SHIPMENT" ||
      partyType == "SHIPMENT_COMPANY" ||
      this.isAdmin;
    this.isDriverOrAdmin =
      partyType == "DRIVER" || partyType == "DRIVER_LEADER" || this.isAdmin;
    this.isDriver = partyType == "DRIVER" || partyType == "DRIVER_LEADER";
    const driver = this.$store.getters.driver;
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.secondUploadDetail = dataBranch.partyGroupConfigCacheMap
      .orderDetailOperate_secondUploadDetail
      ? dataBranch.partyGroupConfigCacheMap
          .orderDetailOperate_secondUploadDetail.configValue
      : 0;
    if (driver) {
      this.driverType = driver.driverType;
    }
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.findList();
    this.waybillManage_wait_search_button = getLimit(
      "waybillManage_wait_search_button"
    ); //查询
    this.waybillManage_wait_detail_button = getLimit(
      "waybillManage_wait_detail_button"
    ); //详情
    this.waybillManage_wait_cancelOrder_button = getLimit(
      "waybillManage_wait_cancelOrder_button"
    ); //取消订单
    this.waybillManage_wait_cancelAffirm_button = getLimit(
      "waybillManage_wait_cancelAffirm_button"
    ); //取消确认
    this.waybillManage_wait_sendOrder_button = getLimit(
      "waybillManage_wait_sendOrder_button"
    ); //派单
    this.waybillManage_wait_load_button = getLimit(
      "waybillManage_wait_load_button"
    ); //装货
    this.waybillManage_wait_unload_button = getLimit(
      "waybillManage_wait_unload_button"
    ); //卸货
    this.waybillManage_wait_loadAffirm_button = getLimit(
      "waybillManage_wait_loadAffirm_button"
    ); //装货确认
    this.waybillManage_wait_reload_button = getLimit(
      "waybillManage_wait_reload_button"
    ); //重新装货
    this.waybillManage_wait_unloadAffirm_button = getLimit(
      "waybillManage_wait_unloadAffirm_button"
    ); //卸货确认
    this.waybillManage_wait_reunload_button = getLimit(
      "waybillManage_wait_reunload_button"
    ); //重新卸货
    this.waybillManage_wait_exchange_button = getLimit(
      "waybillManage_wait_exchange_button"
    ); //调单
    this.waybillManage_wait_del_button = getLimit(
      "waybillManage_wait_del_button"
    ); //删除
  },
  methods: {
    showBtnsHandler(row) {
      let isDriverHeader = false;
      if (this.driverType == 1) {
        isDriverHeader = true;
      }
      const btnArr = [];
      if (this.isAdmin && row.status < 4) {
        btnArr.push("del"); // 删除
      }
      if (row.status == 1 && row.isCancel == 0 && !this.isAdmin) {
        btnArr.push("cancelOrder"); // 取消订单
      }
      if (
        row.status == 1 &&
        row.isCancel == 1 &&
        ((row.cancelType == 0 && this.isShipmentOrAdmin) ||
          ((row.cancelType == 1 || row.cancelType == 2) && this.isDriver))
      ) {
        btnArr.push("cancelAffirm"); // 取消确认
      }
      if (row.status < 3 && !row.driverCode && isDriverHeader) {
        btnArr.push("sendOrder"); // 派单
      }
      if (
        row.status == 1 &&
        row.driverCode &&
        row.isCancel != 1 &&
        this.isDriverOrAdmin &&
        this.isAllowLoadOrUnload === "1"
      ) {
        btnArr.push("load"); // 装货
      }
      if (
        row.status == 2 &&
        row.isLoadingConfirm == 0 &&
        this.isShipmentOrAdmin
      ) {
        btnArr.push("loadAffirm"); // 装货确认
      }
      if (
        (row.status == 2 || row.status == 3) &&
        this.secondUploadDetail == 1 &&
        this.isShipmentOrAdmin
      ) {
        btnArr.push("reload"); // 重新装货
      }
      if (row.status == 2 && row.isLoadingConfirm == 1) {
        // btnArr.push("unload"); // 卸货
      }
      if (
        row.status == 3 &&
        row.isUnloadingConfirm == 0 &&
        this.isShipmentOrAdmin
      ) {
        btnArr.push("unloadAffirm"); // 卸货确认
      }
      if (
        row.status == 3 &&
        this.secondUploadDetail == 1 &&
        this.isShipmentOrAdmin
      ) {
        btnArr.push("reunload"); // 重新卸货
      }
      if (
        (row.status == 1 || row.status == 2) &&
        row.isCancel != 1 &&
        ((row.driverCode && isDriverHeader) || this.isShipmentOrAdmin)
      ) {
        btnArr.push("exchange"); // 调单
      }
      row.btnArr = btnArr;
    },
    // 取消订单
    cancelOrderFunc(row) {
      this.$refs.cancelOrderRef.init(row);
      this.cancelOrderFlag = true;
    },
    // 装货弹窗
    loadFunc(row) {
      this.$refs.loadRef.init(row);
      this.loadFlag = true;
    },
    /*positionFunc(row) {
        this.$refs.positionRef.init(row.code,'waitTransport');
        this.positionFlag = true;
      },*/
    //运输单详情
    WaybillDetails(row, item) {
      this.$refs.WaybillDetails.Getdetails(row, false);
      this.WaybillFalse = true;
      this.wayInfo = item;
    },
    cancelAffirmFunc(row) {
      this.$refs.cancelAffirmRef.init(row);
      this.cancelAffirmFlag = true;
    },
    sendOrderFunc(row) {
      this.$refs.sendOrderRef.init(row);
      this.sendOrderFlag = true;
    },
    unloadFunc(row) {
      this.$refs.unloadRef.init(row);
      this.unloadFlag = true;
    },
    loadAffirmFunc(row) {
      this.$refs.loadAffirmRef.init(row);
      this.loadAffirmFlag = true;
    },
    reloadFunc(row) {
      this.$refs.reloadRef.init(row);
      this.reloadFlag = true;
    },
    unloadAffirmFunc(row) {
      this.$refs.unloadAffirmRef.init(row);
      this.unloadAffirmFlag = true;
    },
    reunloadFunc(row) {
      this.$refs.reunloadRef.init(row);
      this.reunloadFlag = true;
    },
    exchangeFunc(row) {
      this.$refs.exchangeRef.init(row);
      this.exchangeFlag = true;
    },
    delFunc(row) {
      this.$confirm("请确认是否删除运单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading();
          //setTimeout(() => {
          deleteDetail({ codes: row.code }).then(response => {
            this.$message({
              type: "success",
              message: response.msg
            });
            this.findList();
            rLoading.close();
          });
          //}, 1000000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 翻译状态
    formatterisTransferSearch({ cellValue }) {
      const item = this.statusOptions.find(item1 => item1.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item1 => item1.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // ------------------
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["platformPrepayment"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "shipperDeliveryFee") {
            return this.sumObject.shipperDeliveryFee;
          }
          if (column.property === "deliveryFeePractical") {
            return this.sumObject.deliveryFeePractical;
          }
          if (column.property === "deliveryCashFee") {
            return this.sumObject.deliveryCashFee;
          }
          if (column.property === "taxFee") {
            return this.sumObject.taxFee;
          }
          if (column.property === "payTaxAmount") {
            return this.sumObject.payTaxAmount;
          }
          if (column.property === "payOil") {
            return this.sumObject.payOil;
          }
          if (column.property === "payAmount") {
            return this.sumObject.payAmount;
          }
          if (column.property === "taxPayFee") {
            return this.sumObject.taxPayFee;
          }
          if (column.property === "distance") {
            return this.sumObject.distance;
          }
          if (column.property === "deliveryOilFee") {
            return this.sumObject.deliveryOilFee;
          }
          if (column.property === "deliveryFeeDeserved") {
            return this.sumObject.deliveryFeeDeserved;
          }
          if (column.property === "weight") {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          if (column.property === "loadQuantity") {
            return (
              this.sumObject.loadQuantityTon +
              "吨//" +
              this.sumObject.loadQuantityCubicMeter +
              "方//" +
              this.sumObject.loadQuantityPieces +
              "件"
            );
          }
          if (column.property === "unloadQuantity") {
            return (
              this.sumObject.unloadQuantityTon +
              "吨//" +
              this.sumObject.unloadQuantityCubicMeter +
              "方//" +
              this.sumObject.unloadQuantityPieces +
              "件"
            );
          }
          if (column.property === "settlementWeight") {
            return (
              this.sumObject.settlementWeightTon +
              "吨//" +
              this.sumObject.settlementWeightCubicMeter +
              "方//" +
              this.sumObject.settlementWeightPieces +
              "件"
            );
          }
          return "-";
        })
      ];
    },
    // ------------------
    fatherSubmitFunc(modelFlag) {
      switch (modelFlag) {
        case "cancelOrder":
          this.cancelOrderFlag = false;
          break;
        case "cancelAffirm":
          this.cancelAffirmFlag = false;
          break;
        case "sendOrder":
          this.sendOrderFlag = false;
          break;
        case "load":
          this.loadFlag = false;
          break;
        case "loadAffirm":
          this.loadAffirmFlag = false;
          break;
        case "reload":
          this.reloadFlag = false;
          break;
        case "unload":
          this.unloadFlag = false;
          break;
        case "unloadAffirm":
          this.unloadAffirmFlag = false;
          break;
        case "reunload":
          this.reunloadFlag = false;
          break;
        case "exchange":
          this.exchangeFlag = false;
          break;
        case "position":
          this.positionFlag = false;
          break;
        default:
      }
      this.findList();
    },
    fatherCancelFunc(modelFlag) {
      switch (modelFlag) {
        case "cancelOrder":
          this.cancelOrderFlag = false;
          break;
        case "cancelAffirm":
          this.cancelAffirmFlag = false;
          break;
        case "sendOrder":
          this.sendOrderFlag = false;
          break;
        case "load":
          this.loadFlag = false;
          break;
        case "loadAffirm":
          this.loadAffirmFlag = false;
          break;
        case "reload":
          this.reloadFlag = false;
          break;
        case "unload":
          this.unloadFlag = false;
          break;
        case "unloadAffirm":
          this.unloadAffirmFlag = false;
          break;
        case "reunload":
          this.reunloadFlag = false;
          break;
        case "exchange":
          this.exchangeFlag = false;
          break;
        case "position":
          this.positionFlag = false;
          break;
        default:
      }
    },
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 取消状态翻译
    formatterCancel({ cellValue }) {
      console.log("取消状态翻译", cellValue);
      return cellValue === 1 ? "已取消" : "未取消";
      // const item = this.cancelOptions.find(item => item.value === cellValue);
      // return item ? item.label : "";
    },
    // 支付状态翻译
    formatterPayStatus({ cellValue }) {
      const item = this.payOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 获取列表
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "ntocc-tms-api/orderDetail",
          method: "get",
          params: { ...this.listQuery, deleted: "1" }
        }).then(response => {
          this.loading = false;
          const records = response.data.records;
          if (records && records.length > 0) {
            for (const i in records) {
              this.showBtnsHandler(records[i]);
            }
            this.tableData = records;
          } else {
            this.tableData = [];
          }
          this.tableData.forEach(item => {
            item.weight = item.weight + item.coalUnitName;
            item.coalPrice = item.coalPrice + "元/" + item.coalUnitName;
            item.maxPrice = item.maxPrice + item.isTrunkName;
            item.taxPrice = item.taxPrice + item.isTrunkName;
            item.realPrice = item.realPrice + item.isTrunkName;
          });
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          resolve();
        });
      });
    },
    // 审核
    funcRiview(code) {
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译通用是否状态
    formatterCommonStatus({ cellValue }) {
      const item = this.commonStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    rowClassName({ row, rowIndex }) {
      if (row.deleted == "1") {
        return "row-grey";
      }
    }
  }
};
</script>
<style scoped lang="scss">
.vxe-button {
  margin-left: 0;
}

::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}
::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
/* 针对微信浏览器定制滚动条 */
::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}

::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
</style>

<style>
.mytable-style .vxe-body--row.row-grey {
  background-color: rgb(216, 216, 216);
  color: rgb(194, 194, 194);
}
</style>
